export const headerConfig = {
    menu : [
        {
            id: 1,
            label: 'Video',
            routerLink: '/'
        },
        {
            id: 2,
            label: 'Publisher',
            routerLink: 'publisher'
        },
        {
            id: 3,
            label: 'ORTB Validator',
            routerLink: 'ortbValidator'
        },
        {
            id: 4,
            label: 'Analysis',
            routerLink: 'analysis'
        },
        {
          id: 5,
          label: 'Test Tag',
          routerLink: 'testTag'
      }
    ]
};
